import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'

const sysCorpCust = ds.QSysCorpCust.using(dsc)

// 华贸分公司
sysCorpCust.getsysCorpCustCsOffice = function (data) {
    let whereParams = ''
    if(data.csCustId) {
        whereParams = sysCorpCust.csCustId.eq$(data.csCustId)
    }
    if(data.csCustId && data.corpNameCn) {
        whereParams = sysCorpCust.csCustId.eq$(data.csCustId).and(sysCorpCust.corpNameCn.like$("%"+data.corpNameCn+"%"))
    }
    return sysCorpCust
      .select(sysCorpCust.fieldContainer())
      .where(whereParams)
      .paging(data.page, data.limit)
      .tag('getsysCorpCustCsOffice')
      .execute()
}
  
export default sysCorpCust